module.exports = __webpack_public_path__ + "img/BOHOLCSR.4a0ffbbd.jpg";